angular.module("digitalLeasing.module").component("contractWarranties", {
    templateUrl: "ng/components/digitalLeasing/goodManagement/contractWarranties/contractWarranties.view.html",
    bindings: {
        model: "=", //preventivo
        financial: "=",
        customer: "=",
        componentIsOk: "&",
        componentIsNotOk: "&",
        warrantyList: "&",
        snapshot: '<',
        portalRunned: '<'
    },
    controllerAs: "contractWarrantiesCtrl",
    controller: ContractWarrantiesController
});

function ContractWarrantiesController(
    Garanzia,
    $modalService,
    Garante,
    $timeout,
    $simulationService,
    Pf
) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            warrantyList: [],
            elementToAdd: [],
            enableConfButton: false,
            numberOfWarranties: 0,
            totalWarrantiesAmount: "",
            enableModal: false,
            index: null,
            garanti: [],
            elementToSave: "",
            guarSelected: [],
            maxGuarLength: 50,
            enableToltipGuar: []
        }

        if (self.model.garanzie) {
            self.model.garanzie.sort(function (a, b) {
                if (parseInt(a.id) < parseInt(b.id)) {
                    return -1
                } else {
                    return 1
                }
            });

            self.supportModel.warrantyList = self.model.garanzie;

            populateGuarTable();
        }
        checkAndEnableTooltip();
    };

    self.modifyWarranty = function (warranty, index) {
        self.supportModel.index = index;
        self.supportModel.elementToAdd = Object.assign({}, warranty);
        self.supportModel.elementToAdd.id = warranty.id;
        getLinkedGaranti();
    }

    self.addWarrantyRow = function () {
        self.supportModel.elementToAdd = {};
        getLinkedGaranti();
    }

    self.removeWarranty = function (warranty) {

        var index = self.supportModel.warrantyList.findIndex(function (el) {
            return el.id === warranty.id
        });
        if (index != -1) {
            self.supportModel.warrantyList.splice(index, 1);
            self.supportModel.totalWarrantiesAmount = self.supportModel.totalWarrantiesAmount - parseInt(warranty.importoInizialeGaranzia);
        }

        self.model.garanzie = self.supportModel.warrantyList;

        //riassegno gli id
        var newId = 1;
        self.model.garanzie.forEach(function (element) {
            element.id = newId.toString();
            newId++;
        });

        self.warrantyList({
            warranties: self.model.garanzie
        });
        populateGuarTable();
    }

    self.changeZIndex = function (warranty) {
        if (self.supportModel.warrantyList.length > 1 &&
            typeof warranty.elementToAdd.codice == "undefined") {
            self.supportModel.warrantyList.splice(self.supportModel.warrantyList.length - 1, 1);
        }
        $modalService.closeModal("insertWarrantyModal");
        self.supportModel.enableModal = false;
        $('.financial-leasing__footer').css("z-index", "1");

    }

    self.saveWarrantyInfo = function () {
        self.supportModel.guarSelected = [];
        if (self.supportModel.elementToSave) {
            var index = self.model.garanzie.findIndex(function (el) {
                return el.id === self.supportModel.elementToSave.id
            });

            if (index != -1) {
                self.model.garanzie.splice(index, 1);
            }
            self.model.garanzie.push(self.supportModel.elementToSave);
            self.model.garanzie.sort(function (a, b) {
                if (parseInt(a.id) < parseInt(b.id)) {
                    return -1
                } else {
                    return 1
                }
            });

            self.warrantyList({
                warranties: self.model.garanzie
            });
            console.log("Garanzie Added: ", self.financial.leasingData.preventivo.garanzie);

            populateGuarTable();
            checkAndEnableTooltip();

            $modalService.closeModal("insertWarrantyModal");
            self.supportModel.enableModal = false;
            $('.financial-leasing__footer').css("z-index", "1");

            self.supportModel.index = null;
        }
    }

    self.warrantyIsOk = function () {
        self.supportModel.enableConfButton = true;
    }

    self.warrantyIsNotOk = function () {
        self.supportModel.enableConfButton = false;
    }

    self.warrentIsSelected = function () {
        // self.financial.financialCustomer.metadata.riUserF.listaPf = self.financial.financialCustomer.metadata.riUserF.listaPf.map(x => {
        //     return Pf.build(x);
        // })

        var checkRiuserF = self.financial.financialCustomer.metadata.riUserF.listaPf
            .some(function (element) {
                return element.garante && element.garante.selected == true && element.isOk == true;
            })

        var checkAzienda = self.financial.financialCustomer.metadata.aziendeGaranti.length;

        return checkRiuserF || checkAzienda;
    }

    self.warrantyToSave = function (warranty) {
        if (warranty) {
            self.supportModel.elementToSave = warranty;
        }
    }

    var getLinkedGaranti = function () {
        self.showLoader = true;
        $simulationService.getLinkedGaranti(self.financial)
            .then(function (response) {

                self.financial.financialCustomer.metadata.aziendeGaranti = response.aziendeGaranti;
                self.supportModel.listaGaranti = [];
                response.riferimentiGaranti.forEach(function (element) {

                    self.supportModel.listaGaranti.push(Garante.build(element));
                })

                response.aziendeGaranti.forEach(function (riUserG) {
                    self.financial.financialCustomer.metadata.riUserF.listaPf.forEach(function (riUserF) {
                        if (riUserF.cf === riUserG.cfFirmatario) {
                            for (var i = 0; i < self.supportModel.listaGaranti.length; i++) {
                                if (self.supportModel.listaGaranti[i].cfFirmatario === riUserG.cfFirmatario) {
                                    self.supportModel.listaGaranti[i].azienda = true;
                                    self.supportModel.listaGaranti[i].firmatario.selected = true;
                                    self.supportModel.listaGaranti[i].denominazione = riUserG.ragioneSociale;
                                    self.supportModel.listaGaranti[i].cfGarante = riUserG.piva;
                                    self.supportModel.listaGaranti[i].cfFirmatario = riUserG.cfFirmatario;
                                    self.supportModel.listaGaranti[i].nomeFirmatario = riUserF.nome;
                                    self.supportModel.listaGaranti[i].cognomeFirmatario = riUserF.cognome;
                                }
                            }
                        }
                    });
                });

                self.supportModel.enableModal = true;
                $timeout(function () {
                    self.showLoader = false;

                    if (self.model.garanzie.length > 0) {
                        var lastIdBene = 1;
                        self.model.garanzie.forEach(function (element) {
                            lastIdBene = element.idBene;
                        });

                        var newIdBene = parseInt(lastIdBene) + 1;
                        self.supportModel.elementToAdd = Garanzia.build({
                            idBene: newIdBene
                        });
                    } else {
                        self.supportModel.elementToAdd = Garanzia.build({
                            idBene: "1"
                        });
                    }

                    var oldGarantSelected = self.supportModel.warrantyList[self.supportModel.index] &&
                        self.supportModel.warrantyList[self.supportModel.index].listaGaranti
                            .filter(function (element) {
                                return element.garante.selected == true;
                            })
                    self.supportModel.listaGaranti.forEach(function (newGarant) {
                        oldGarantSelected && oldGarantSelected.forEach(function (oldGarant) {
                            if (oldGarant.cfGarante == newGarant.cfGarante) {
                                newGarant.garante.selected = true;
                            }
                        })
                    })

                    self.supportModel.elementToAdd.listaGaranti = JSON.parse(JSON.stringify(self.supportModel.listaGaranti));

                    $modalService.openModal("insertWarrantyModal");
                    $('.financial-leasing__footer').css("z-index", "-1");
                }, 1000)
            })
            .catch(function (error) {
                console.log(error);
                self.showLoader = false;
            })
    }

    var checkAndEnableTooltip = function () {
        $timeout(function () {
            if (self.supportModel.guarSelected.length > 0) {
                for (var i = 0; i < self.supportModel.guarSelected.length; i++) {
                    if (self.supportModel.guarSelected[i].length > self.supportModel.maxGuarLength) {
                        self.supportModel.enableToltipGuar[i] = true;
                    } else {
                        self.supportModel.enableToltipGuar[i] = false;
                    }
                }
            }
        }, 500);
    }

    var populateGuarTable = function () {
        var guarList = "";
        self.supportModel.guarSelected = [];
        for (var i = 0; i < self.supportModel.warrantyList.length; i++) {
            self.supportModel.warrantyList[i].listaGaranti.forEach(function (el) {
                if (el.garante.selected) {
                    guarList += el.denominazione;
                    guarList += "; ";
                    if (self.supportModel.guarSelected.length > 0) {
                        self.supportModel.guarSelected[i] = [];
                        self.supportModel.guarSelected[i] = guarList;
                    } else {
                        self.supportModel.guarSelected[0] = guarList;
                    }
                }
            })
            guarList = "";
        }
    }
}